/* import __COLOCATED_TEMPLATE__ from './screen-config-editor-screen.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class ScreenConfigEditorScreenComponent extends Component
{
	@action updateId(event)
	{
		this.args.onUpdate({ ...this.args.screen, id: parseInt(event.target.value) || 0 });
	}

	// Column management
	@action addColumn()
	{
		const newConfig = [...this.args.screen.config, []];
		this.args.onUpdate({ ...this.args.screen, config: newConfig });
	}

	@action removeColumn(columnIndex)
	{
		const newConfig = this.args.screen.config.filter((_, i) => i !== columnIndex);
		this.args.onUpdate({ ...this.args.screen, config: newConfig });
	}

	// Card management within columns
	@action addCard(columnIndex)
	{
		const newConfig = [...this.args.screen.config];
		const newColumn = [...newConfig[columnIndex], {
			classGroupId: '',
			name: 'New Card',
			precision: 0,
			filterFinishedOnly: true,
			columns: []
		}];
		newConfig[columnIndex] = newColumn;
		this.args.onUpdate({ ...this.args.screen, config: newConfig });
	}

	@action removeCard(columnIndex, cardIndex)
	{
		const newConfig = [...this.args.screen.config];
		const newColumn = newConfig[columnIndex].filter((_, i) => i !== cardIndex);
		newConfig[columnIndex] = newColumn;
		this.args.onUpdate({ ...this.args.screen, config: newConfig });
	}

	@action updateCard(columnIndex, cardIndex, updatedCard)
	{
		const newConfig = [...this.args.screen.config];
		const newColumn = [...newConfig[columnIndex]];
		newColumn[cardIndex] = updatedCard;
		newConfig[columnIndex] = newColumn;
		this.args.onUpdate({ ...this.args.screen, config: newConfig });
	}
}
